import { Comment } from '@/types';
import { PasseriniAPI } from './apiService';

export class CommentsService {
  /**
   * Obtiene todos los comentarios de un trámite
   */
  static async getComments(tramiteId: number): Promise<Comment[]> {
    try {
      const response = await PasseriniAPI.get(`/tramites/${tramiteId}/comments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching comments:', error);
      throw error;
    }
  }

  /**
   * Crea un nuevo comentario
   */
  static async createComment(tramiteId: number, comment: string): Promise<Comment> {
    try {
      const response = await PasseriniAPI.post(`/tramites/${tramiteId}/comments`, {
        comment
      });
      return response.data;
    } catch (error) {
      console.error('Error creating comment:', error);
      throw error;
    }
  }

  /**
   * Crea una respuesta a un comentario
   */
  static async createReply(
    tramiteId: number,
    parentCommentId: number,
    comment: string
  ): Promise<Comment> {
    try {
      const response = await PasseriniAPI.post(
        `/tramites/${tramiteId}/comments/${parentCommentId}/replies`,
        { comment }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating reply:', error);
      throw error;
    }
  }

  /**
   * Actualiza un comentario existente
   */
  static async updateComment(
    tramiteId: number,
    commentId: number,
    comment: string
  ): Promise<Comment> {
    try {
      const response = await PasseriniAPI.put(
        `/tramites/${tramiteId}/comments/${commentId}`,
        { comment }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating comment:', error);
      throw error;
    }
  }

  /**
   * Elimina un comentario
   */
  static async deleteComment(tramiteId: number, commentId: number): Promise<void> {
    try {
      await PasseriniAPI.delete(`/tramites/${tramiteId}/comments/${commentId}`);
    } catch (error) {
      console.error('Error deleting comment:', error);
      throw error;
    }
  }
}

export default CommentsService;
